"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return getColumnPropsFromUIDT;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
async function getColumnPropsFromUIDT(column, source) {
    var _column_meta;
    const sqlUi = _nocodbsdk.SqlUiFactory.create(await source.getConnectionConfig());
    const colProp = sqlUi.getDataTypeForUiType(column, (column == null ? void 0 : (_column_meta = column['meta']) == null ? void 0 : _column_meta['ag']) ? 'AG' : 'AI');
    const newColumn = _extends({
        rqd: false,
        pk: false,
        ai: false,
        cdf: null,
        un: false,
        dtx: 'specificType'
    }, colProp);
    newColumn.dtxp = sqlUi.getDefaultLengthForDatatype(newColumn.dt);
    newColumn.dtxs = sqlUi.getDefaultScaleForDatatype(newColumn.dt);
    const selectTypes = [
        _nocodbsdk.UITypes.MultiSelect,
        _nocodbsdk.UITypes.SingleSelect
    ];
    if (column && selectTypes.includes(column.uidt)) {
        column.dtxp = typeof column.dtxp === 'string' ? column.dtxp.trim().replace(/'\s*,\s*'/g, "','") : column.dtxp;
    }
    newColumn.altered = column.altered || 2;
    const finalColumnMeta = _extends({}, newColumn, column);
    // Preserve original cdf if it was set (newColumn sets it to null by default)
    if ('cdf' in column && column.cdf !== undefined && column.cdf !== null) {
        finalColumnMeta.cdf = column.cdf;
    }
    // Preserve original unique and ck if they were set
    if ('unique' in column && column.unique !== undefined) {
        finalColumnMeta.unique = column.unique;
    }
    if ('ck' in column && column.ck !== undefined) {
        finalColumnMeta.ck = column.ck;
    }
    sqlUi.adjustLengthAndScale(finalColumnMeta);
    if (finalColumnMeta.uidt === _nocodbsdk.UITypes.CreatedTime && !('column_name' in finalColumnMeta)) {
        finalColumnMeta.column_name = 'created_at';
    } else if (finalColumnMeta.uidt === _nocodbsdk.UITypes.LastModifiedTime && !('column_name' in finalColumnMeta)) {
        finalColumnMeta.column_name = 'updated_at';
    }
    return finalColumnMeta;
}
